import React from 'react'
import {
  Table,
  Button,
  Popup
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'

const OptionalCompareTableHeaderCells = ({mode, comparisonMode, comparisonSelectionNames, selections}) => {
  if (mode==='compare') {
    if (comparisonMode==='juxtaposeCounts'||comparisonMode==='juxtaposeBarsCount'||comparisonMode==='juxtaposeBarsPercent') {
      return comparisonSelectionNames.map(name=>{
        const selection = selections.find(s=>s.id===name);
        return (
          <Table.HeaderCell key={name} style={{paddingLeft: '2px', paddingRight: '2px'}} collapsing textAlign='center'>
            {
              <Popup trigger={
                <Button fluid compact style={{paddingLeft: '0px', paddingRight: '0px'}} color='orange' as={Link} to={'/selection/'+selection.id}>
                  {selection.id}
                </Button>
              } content={
                <span>
                  <strong>{selection.name}</strong><br/>
                  {selection.author}
                </span>
              }/>
            }
          </Table.HeaderCell>
        );
      });
    } else {
      return (
        <Table.HeaderCell collapsing textAlign='center'>
          Overall
        </Table.HeaderCell>
      );
    }
  } else {
    return null;
  }
}

export default OptionalCompareTableHeaderCells